export const api = {
  area: {
    list: '/cms/account/queryAssociationalDeviceTree.json', // 获取区域
    addArea: '/cms/area/addAreaDevGroup/addAreaDevGroup.json', // 获取区域
    fixArea: '/cms/area/updateAreaDevGroup/updateAreaDevGroup.json', // 修改区域
    deleteArea: '/cms/area/deleteAreaDevGroup/deleteAreaDevGroup.json', // 删除区域
    queryArea: '/cms/area/queryAreaDevGroupList/queryAreaDevGroups.json', // 搜索区域
    // queryPersonList: '/vas/personnel/queryPersonList.json', // 查询人员列表
    queryPersonList: '/vas/personnel/queryPersonListApi.json', // 查询人员列表
    detailArea: '/cms/area/queryAreaDevGroup/queryAreaDevGroupDetail.json', //区域详情
  }
}